const INPUT_BG_COLOR = process.env.INPUT_BG_COLOR
const INPUT_BG_COLOR2 = process.env.INPUT_BG_COLOR2
const FIELD_COLOR = process.env.FIELD_COLOR
export default {
  computed: {
    fieldColor () {
      return FIELD_COLOR || 'blue-5'
    },
    inputBgColor () {
      return INPUT_BG_COLOR || 'blue-grey-1'
    },
    inputBgColor2 () {
      return INPUT_BG_COLOR2 || 'blue-grey-2'
    }
  }
}
